import { get } from "../methods";
import { removeLeadingSlash } from "../utils";
var EventType = /* @__PURE__ */ ((EventType2) => {
  EventType2["Event"] = "event";
  EventType2["Article"] = "article";
  EventType2["Brief"] = "brief";
  EventType2["ExternalArticle"] = "external-article";
  return EventType2;
})(EventType || {});
function getCompanyFeed(options, headers = {}) {
  const limitQuery = typeof options.limit === "number" ? `?maxResults=${options.limit}` : "";
  return get({
    url: `dashboard/company/${removeLeadingSlash(options.lookup)}${limitQuery}`,
    headers
  });
}
export {
  getCompanyFeed as default
};
